import React, { useState } from 'react';
import { Box } from '@mui/material';
import Header from '../../Common/Header/Header';
import ServicesWrapper from '../Common/Services/page';
import { QUERY_KEYS_SIH } from '../../Common/hooks/useChartsData';
import { subtitlesMap } from '../Common/maps/subtitleMap';
import { Table } from './AgeGroup/Table';
import { CityServicesWrapper } from './CityServices';
import ChartsContainer from '../../Common/ChartsContainer';

const titleMap = {
    0: 'Atendimentos - Faixa Etária',
    1: 'Atendimentos - Gênero',
    2: 'Atendimentos - Raça/Cor',
    3: 'Atendimentos - Escolaridade',
    4: 'Atendimentos - Município'
};

const renderContent = (activeIndex) => {
    switch (activeIndex) {
        case 0:
            return (
                <ServicesWrapper
                    module={{ sectionTitle: 'do Total de Atendimentos' }}
                    queryConfig={{
                        key: QUERY_KEYS_SIH.AGE_GROUP_PERFIL,
                        url: 'governanceroom/dashboard/sihsus/aih/age'
                    }}
                    subtitlesMap={subtitlesMap}
                >
                    <Table />
                </ServicesWrapper>
            );
        case 1:
            return (
                <ServicesWrapper
                    module={{ sectionTitle: 'do Total de Atendimentos' }}
                    queryConfig={{
                        key: QUERY_KEYS_SIH.GENDER_PERFIL,
                        url: 'governanceroom/dashboard/sihsus/aih/gender'
                    }}
                    subtitlesMap={subtitlesMap}
                />
            );
        case 2:
            return (
                <ServicesWrapper
                    module={{ sectionTitle: 'do Total de Atendimentos' }}
                    queryConfig={{
                        key: QUERY_KEYS_SIH.ETHNICITY_PERFIL,
                        url: 'governanceroom/dashboard/sihsus/aih/ethnicity'
                    }}
                    subtitlesMap={subtitlesMap}
                />
            );
        case 3:
            return (
                <ServicesWrapper
                    module={{
                        title: 'Atendimentos - Escolaridade',
                        sectionTitle: 'do Total de Atendimentos'
                    }}
                    queryConfig={{
                        key: QUERY_KEYS_SIH.EDUCATION_PERFIL,
                        url: 'governanceroom/dashboard/sihsus/aih/education'
                    }}
                    subtitlesMap={subtitlesMap}
                />
            );
        case 4:
            return (
                <CityServicesWrapper
                    queryConfig={{
                        key: QUERY_KEYS_SIH.CITY_PERFIL,
                        url: 'governanceroom/dashboard/sihsus/aih/city'
                    }}
                />
            );
        default:
            return null;
    }
};

export const Perfil = ({ setActiveIndex }) => {
    const [activeIndexLocal, setActiveIndexLocal] = useState(0);

    const handleHomeClick = () => {
        if (setActiveIndex) {
            setActiveIndex(0);
        }
        setActiveIndexLocal(0);
    };

    const menus = [
        {
            title: 'Faixa Etária',
            onclick: () => setActiveIndexLocal(0),
            active: activeIndexLocal === 0
        },
        {
            title: 'Gênero',
            onclick: () => setActiveIndexLocal(1),
            active: activeIndexLocal === 1
        },
        {
            title: 'Raça/Cor',
            onclick: () => setActiveIndexLocal(2),
            active: activeIndexLocal === 2
        },
        {
            title: 'Escolaridade',
            onclick: () => setActiveIndexLocal(3),
            active: activeIndexLocal === 3
        },
        {
            title: 'Município',
            onclick: () => setActiveIndexLocal(4),
            active: activeIndexLocal === 4
        }
    ];

    return (
        <Box className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[activeIndexLocal]}
                    className={`services-container-dashboards`}
                >
                    {renderContent(activeIndexLocal)}
                </ChartsContainer>
            </Box>
        </Box>
    );
};
